export const enum PaymentProviders {
  Klarna = 'Klarna',
  Paypal = 'Paypal',
}

export enum ExpressPaymentKey {
  klarna = 'klarna',
  paypal = 'paypal',
}
